const MAX_VERIFIED_MICROPHONES = 5;

export interface LocalMicrophone {
  device_id: string;
  group_id: string;
  label: string;
  normalized_label: string;
  category: string;
  user_agent: string;
  verified_at: string;
}

function storageKey(userId: number): string {
  return `suno_verified_microphones_${userId}`;
}

export function getVerifiedMicrophones(userId: number): LocalMicrophone[] {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Upserts a verified microphone entry for the given user.
 * Deduplicates by device_id (newest wins), then caps the list at
 * MAX_VERIFIED_MICROPHONES entries to bound localStorage growth.
 *
 * Multiple entries are kept intentionally — Safari and Firefox rotate
 * device IDs across sessions, so the fuzzy-match in assessMicrophone
 * needs previous entries to avoid false "Unverified" results.
 */
export function saveVerifiedMicrophone(
  userId: number,
  mic: LocalMicrophone
): void {
  try {
    const existing = getVerifiedMicrophones(userId);
    const deduped = existing.filter((m) => m.device_id !== mic.device_id);
    const updated = [mic, ...deduped].slice(0, MAX_VERIFIED_MICROPHONES);
    localStorage.setItem(storageKey(userId), JSON.stringify(updated));
  } catch {
    // localStorage may be unavailable (private browsing, quota exceeded).
    // Silently no-op — the user will see "Unverified" on the next session
    // and can re-run setup.
  }
}
